import { BaseFiltroPaginate } from "resources/enums/paginate";
import { useCallback, useState } from "react";
import { ListarEncomendaQuery } from "core/features/encomenda/typings";

export interface FiltroEncomenda extends ListarEncomendaQuery {}

export const filtroDefaultEncomenda: FiltroEncomenda = {
  search: "",
  page: 1,
  limit: BaseFiltroPaginate.Limit,
  statusId: undefined,
  dataInicio: undefined,
  dataFim: undefined,
  pessoaId: undefined,
  unidadeId: undefined,
};

function useFiltroEncomenda() {
  const [filtro, setFiltro] = useState<FiltroEncomenda>(filtroDefaultEncomenda);

  const onChangeFiltro = useCallback((_filtro: Partial<FiltroEncomenda>) => {
    setFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  const onResetFiltro = useCallback((_filtro: Partial<FiltroEncomenda>) => {
    setFiltro({
      ...filtroDefaultEncomenda,
      ..._filtro,
    });
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroEncomenda;
